module.exports = __webpack_public_path__ + "static/media/go-creative.0a126ea7.svg";